import { render, staticRenderFns } from "./ConfigDetail.vue?vue&type=template&id=515719ab&scoped=true&"
import script from "./ConfigDetail.vue?vue&type=script&lang=js&"
export * from "./ConfigDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDetail.vue?vue&type=style&index=0&id=515719ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515719ab",
  null
  
)

export default component.exports